import { Component, DoCheck, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-control-message',
    templateUrl: './control-message.component.html',
    styleUrls: ['./control-message.component.css'],
    standalone: false
})
export class ControlMessageComponent implements DoCheck {
  public _errorMessage:string |undefined |null ;
  @Input() control!: FormControl;
  @Input() message : any;
  constructor(){
    this.message = null;
  }
 ngDoCheck(): void {
   this.errorMessge()
 }
 errorMessge(){
  if(this.control.errors !== null){
    for(const propertyName in this.control.errors ){
      if(this.control.errors.hasOwnProperty(propertyName) && this.control.touched && this.control.invalid  ){
        this._errorMessage = this.getMessage(propertyName);
        break;

      }

    }

  }else{
    this._errorMessage = null;
  }
  return null;
 }
 getMessage(param:any){

if(this.message !== null && this.message.hasOwnProperty(param)){
return this.message[param]
}else{
  return 'Required'
}
 }
}
